import { WinePackageWidgetModel } from '../../models/WinePackageWidgetModel';
import { AvailableText, NotAvailableText } from './components/OrderableText';
import { WinePackagePrices } from './components/WinePackagePrice';
import { WinePackageContent } from './components/WinePackageContent';
import { WinePackageDescription } from './components/WinePackageDescription';
import { WinePackageTitle } from './components/WinePackageTitle';

interface WinePackageContentProps {
  winePackage: WinePackageWidgetModel;
  isShowContent: boolean;
}

/**
 * The WinePackageInfo component renders information about a wine package, including its title,
 * content, description, price, and availability.
 * @param {WinePackageContentProps}  - - `winePackage`: The object containing information about the
 * wine package.
 * @returns The WinePackageInfo component is returning JSX elements.
 */
export const WinePackageInfo = ({ winePackage, isShowContent }: WinePackageContentProps) => {
  return (
    <>
      <div className='w-full'>
        <div className='flex flex-col min-[350px]:gap-0 md:gap-[4px] h-[46px]'>
          <WinePackageTitle winePackage={winePackage} />
          <WinePackageContent isShowContent={isShowContent} winePackage={winePackage} />
        </div>
        <WinePackageDescription winePackage={winePackage} />
      </div>
      <div className={`flex h-[53px] justify-between  w-full ${winePackage.showEurPrice ? 'min-[350px]:mb-[4px] mt-[8px] items-center' : 'min-[350px]:mb-[8px] lg:mt-[12px] items-start'}  lg:mb-[12px]`}>
        <WinePackagePrices winePackage={winePackage} />
        <div className={`flex items-center ${winePackage.showEurPrice ? 'min-[350px]:mb-[20px] md:mb-[20px]' : 'mb-0'} `}>{winePackage.availableQuantity > 0 ? <AvailableText /> : <NotAvailableText />}</div>
      </div>
    </>
  );
};
